import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Toimitus',
    pickup: 'Nouto',
  },
  asap: 'Heti',
  unavailable: 'Ei saatavilla',
  ready_in_time: 'Valmis {{time}} min kuluttua',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Toimitus osoitteeseen {{address}}',
    [ORDER_METHODS.PICKUP]: 'Nouto osoitteesta {{address}}',
  },
  buttons: {
    change: 'Vaihda',
    see_hours: 'Katso aukioloajat',
    change_location: 'Vaihda sijaintia',
    change_time: 'Vaihda aikaa',
  },
};
